'use client';

import Image from 'next/image';

const Hero = () => {
  return (
    <section className="relative min-h-[720px] flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          src="/hero-bg.jpg"
          alt="Woman working out in gym"
          fill
          className="object-cover"
          priority
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-[#45394B]/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 pt-24">
        <div className="max-w-2xl">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            Find Verified Women-Only Fitness Activities Near You
          </h1>
          <p className="text-lg text-white/90 mb-8 max-w-xl">
            From yoga to strength training, browse women-only fitness classes and personal trainers in your area, then book instantly to join a supportive community.
          </p>

          {/* Search Bar */}
          <div className="flex flex-col sm:flex-row gap-3 max-w-xl">
            <div className="flex-1 relative">
              <input
                type="text"
                placeholder="Enter your city, postcode or location"
                className="w-full px-5 py-4 bg-white rounded-xl text-[#2b262e] placeholder:text-[#a0969e] outline-none focus:ring-2 focus:ring-[#8a7490]"
              />
            </div>
            <button className="px-8 py-4 bg-[#8a7490] text-white font-medium rounded-xl hover:bg-[#7a647d] transition-colors whitespace-nowrap">
              Search
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
